import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { Separator } from "@/app/_module/components/ui/separator";

interface FormSectionProps {
  icon: LucideIcon;
  title: string;
  children: ReactNode;
  className?: string;
}

export const FormSection = function({
  icon: Icon,
  title,
  children,
  className = "",
}: FormSectionProps) {
  return (
    <div className={`space-y-6 ${className}`}>
      <div className="flex items-center gap-3">
        <div className="p-2 bg-primary/10 rounded-lg">
          <Icon className="h-5 w-5 text-primary" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
      </div>
      <div className="w-full">{children}</div>
      <Separator className="my-8" />
    </div>
  );
}
